import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import MuiStylesFooterContainer from "./MuiStylesFooterContainer";
import { AgendaIcon } from "~/components/common/icons/Icons";
import { Gift } from "~/components/common/icons/Icons";
import { Fragment } from "react";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import { useTranslation } from "react-i18next";
import { HomeOutlined } from "@material-ui/icons";
import _ from "lodash";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { authRenew } from "~/services/loginService";
import businessAction from "~/store/actions/businessAction";
import Constants from "~/helpers/enums/Constants";
import checkoutServices from "~/services/checkoutServices";
import DialogSelectBusiness from "~/components/common/dialog/dialogSelectBusiness";

const FooterContainer = (props) => {
	const { businessesList } = props;
	const classes = MuiStylesFooterContainer();
	const { cancellationPolicy } = useSelector((store) => store.cancellation);
	const { business } = useSelector((store) => store.business);
	const { coupons } = useSelector((store) => store.coupons);
	const { user } = useSelector((store) => store.auth);
	const meStore = useSelector((store) => store.me);
	

	const dispatch = useDispatch();
	const { t } = useTranslation();

	const [loading, setLoading] = useState(false);
	const [openBusinessModal, setOpenBusinessModal] = useState(false);
	
	// Verifica se está na rota de reservas
	const isReservationsRoute = props.location.pathname.includes("/reservas");

	const sectors = JSON.parse(localStorage.getItem("@prit-web/sectors"));

	const currentUser = meStore?.me || user || {};
	const isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser?.id === business?.ownerId;

	const handleScheduleReservationsClick = () => {
		if (user && business && (user.isAnonymous || !user.uid)) {
			props.history.push(`/login/options`, {
				goBackRoute: `/reservas/${business?.id}`,
				goBackRouteProps: props.location.state,
			});
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent('Clicou_Em_Reservas', {}, currentUser, business);
			}
			props.history.push(`/reservas/${business?.id}`);
		}
	};

	const loginAutomatic = async (config) => {
		try {
			props.setLoading(true);
			const auth = getAuth();
				sessionStorage.setItem("@prit-web/tokenAppAuth", props?.token);
				const config = {
					headers: {
						Authorization: `Bearer ${props?.token}`,
					},
				};
			const res = await authRenew(config);
			await signInWithCustomToken(auth, res?.data?.message).then((authUser) => {
				localStorage.setItem("@prit-web/accessToken", authUser?.accessToken);
				localStorage.setItem("@prit-web/accessTokenExpirationTime", Date.now() + 3600000);
				dispatch(businessAction.getBusiness(props?.businessId));
				checkoutServices.me().then((res) => {
					localStorage.setItem("@prit-web/userId", res?.data?.id)
					dispatch({ type: Constants.ME, payload: { me: res.data } });
				})
				.then(() => {
					props.history.push(`/reservas/${business?.id}`);
				})
			})
		} finally {
			props.setLoading(false);
			sessionStorage.removeItem("@prit-web/tokenAppAuth");
		}
	};

	const handleLoginBusiness = async () => {
		if (user && business && (user.isAnonymous || !user.uid)) {
			if (props?.token) {
				await loginAutomatic();
			} else {
				props.history.push(`/business/link/${business?.id}${props?.token ? '/' + props?.token : ''}`, {
					goBackRoute: `/reservas/${business?.id}`,
					goBackRouteProps: props.location.state,
				});
			}
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent('Clicou_Em_Reservas', {}, currentUser, business);
			}
			props.history.push(`/reservas/${business?.id}`);
		}
	};

	const handleScheduleClick = () => {
		if (!business?.id && businessesList && businessesList.length === 1) {
			return props.history.push(`/business/${businessesList[0]?.id}`);
		}

		// Se estiver na rota de reservas e houver lista de businesses, abre o modal
		if (isReservationsRoute && businessesList && businessesList.length > 0 && !business?.id) {
			setOpenBusinessModal(true);
		} else {
			// Comportamento padrão: redireciona para o business atual
			props.history.push(`/business/${business?.id}`);
		}
	};

	const handleScheduleClickNotifications = () => {
		if (user && business && (user.isAnonymous || !user.uid)) {
			props.history.push(`/login/options`, {
				goBackRoute: `/notificacoes/${business?.id}`,
				goBackRouteProps: props.location.state,
			});
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent('Clicou_Em_Notificacoes', {}, currentUser, business);
			}
			props.history.push(`/notificacoes/${business?.id}`);
		}
	};

	const handleScheduleClickIndications = () => {
		if (user && business && (user.isAnonymous || !user.uid)) {
			props.history.push(`/login/options`, { goBackRoute: `/indicacoes`, goBackRouteProps: props.location.state });
		} else {
			props.history.push(`/indicacoes`);
		}
	};

	const handleScheduleClickCoupon = () => {
		localStorage.setItem("@prit-web/NoCoupon", true);
		if (user && business && (user.isAnonymous || !user.uid)) {
			props.history.push(`/login/options`, {
				goBackRoute: `/cupons/${business?.id}`,
				goBackRouteProps: props.location.state,
			});
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent('Clicou_Em_Cupons', {}, currentUser, business);
			}
			props.history.push(`/cupons/${business?.id}`);
		}
	};

	return (
		<Fragment>
			<DialogSelectBusiness
				open={openBusinessModal}
				onClose={() => setOpenBusinessModal(false)}
				onSelect={(businessId) => {
					props.history.push(`/business/${businessId}`);
					setOpenBusinessModal(false);
				}}
				businessesList={businessesList || []}
				history={props.history}
			/>
			{user && !user?.isAnonymous ? (
				<>
					<Divider />
					<div style={{ display: "flex", flexDirection: "row" }}>
						<Grid container justifycontent="center" className={classes.footer}>
							{(business || (businessesList && businessesList.length > 0)) && (
								<Button
									className={coupons && coupons.items_list.length > 0 ? classes.buttonWithCoupon : classes.button}
									style={{ backgroundColor: props.section === "agendar" ? "rgb(136 136 136 / 28%)" : "#fff" }}
									onClick={() => handleScheduleClick()}>
									<HomeOutlined />
									<Typography className={classes.nameContainer}>{t("Schedule")}</Typography>
								</Button>
							)}
							<Button
								className={classes.button}
								style={{ backgroundColor: props.section === "reservas" ? "rgb(136 136 136 / 28%)" : "#fff" }}
								onClick={() => handleScheduleReservationsClick()}>
								<AgendaIcon />
								<Typography className={classes.nameContainer}>{t("Reservations")}</Typography>
							</Button>
							{/* @Comment: Reativar após melhorar o fluxo */}
							{/* {coupons && coupons.items_list.length > 0 && (
								<Button
									className={coupons && coupons.items_list.length > 0 ? classes.buttonWithCoupon : classes.button}
									style={{ backgroundColor: props.section === "cupons" ? "rgb(136 136 136 / 28%)" : "#fff" }}
									onClick={() => {
										handleScheduleClickCoupon();
									}}>
									<ConfirmationNumberOutlinedIcon />
									<Typography className={classes.nameContainer}>{t("Coupons")}</Typography>
								</Button>
							)} */}

							<Button
								className={classes.button}
								style={{ backgroundColor: props.section === "indicacoes" ? "rgb(136 136 136 / 28%)" : "#fff" }}
								onClick={() => handleScheduleClickIndications()}>
								<Gift />
								<Typography className={classes.nameContainer}>{t("Rewards")}</Typography>
							</Button>
							<Button
								className={classes.button}
								style={{ backgroundColor: props.section === "notificações" ? "rgb(136 136 136 / 28%)" : "#fff" }}
								onClick={() => handleScheduleClickNotifications()}>
								<NotificationsNoneIcon></NotificationsNoneIcon>
								<Typography className={classes.nameContainer}>{t("Notifications")} </Typography>
							</Button>
						</Grid>
					</div>
				</>
			) : (
				<div className={classes.footerLoginAnonymous} onClick={() => handleLoginBusiness()}>
					<Typography className={classes.footerAnonymousText}>{t('I am a customer View my reserved times')}</Typography>
				</div>
			)}
		</Fragment>
	);
};

export default withRouter(FooterContainer);
